// @flow
import styled from 'styled-components';

export const OfflinePageLink = styled.a`color: ${props => props.theme.mainBrandColor};`;
export const PhoneNumberStyles = styled.p`text-align: center;`;
export const RemoveDeviceOffset = styled.span`margin-left: 2rem;`;



// WEBPACK FOOTER //
// ./src/components/widgets/device-offline/styles.js